import AppLogotypeTpl from './app-logotype.html';
//
const compConfig = {
	template: AppLogotypeTpl,
	controller: () => {},
};
let compMod = angular.module('mod.cmp.appLogotype', []).component('appLogotype', compConfig);
export default (compMod = compMod.name);
